// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jM1x5hhcusURBtKf6Ngk{background:var(--background-primary-inverted-primary);width:280px;box-shadow:var(--menu-shadow);border-radius:8px}.jM1x5hhcusURBtKf6Ngk aside{height:395px;box-shadow:none;border:none;border-radius:12px;padding-top:8px}.jM1x5hhcusURBtKf6Ngk aside input{border:1px solid var(--primary-color-gray-3);border-radius:8px}.jM1x5hhcusURBtKf6Ngk aside .active-category-indicator-wrapper{margin-bottom:4px}.jM1x5hhcusURBtKf6Ngk aside .emoji-group:before{font-size:11px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emoji": `jM1x5hhcusURBtKf6Ngk`
};
export default ___CSS_LOADER_EXPORT___;
